/**
 * Web Share (`navigator.share`) is missing on desktop Linux, so Partager
 * (Lien / PDF) would silently no-op. Android's UA contains "Linux" but
 * implements the API — gate on the capability, not the OS name.
 */
export function peutUtiliserWebShare(): boolean {
    return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}
